import { doc, serverTimestamp, updateDoc } from 'firebase/firestore'
import { db } from '@/lib/firebase'

export async function updateMatch(matchId: string, data: any): Promise<void> {
  const matchRef = doc(db, 'matches', matchId)
  await updateDoc(matchRef, {
    ...data,
    updatedAt: serverTimestamp()
  })
}
